import {
  BaseField,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  withConditional,
} from "@bleu.builders/ui";
import React from "react";

import { CpfCnpj } from "#/components/CpfCnpjInupt";

interface CPFCNPJFieldProps extends BaseField {}

export const CPFCNPJField = withConditional<CPFCNPJFieldProps>(
  ({ form, field }) => {
    return (
      <FormField
        control={form.control}
        name={field.name}
        render={({ field: formField }) => (
          <FormItem className="w-full">
            <FormLabel tooltip={field.tooltip}>{field.label}</FormLabel>
            <FormDescription>{field.description}</FormDescription>
            <FormControl>
              <CpfCnpj value={formField.value} onChange={formField.onChange} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  },
);
